import React from "react";
import { Route, Switch, Link } from "react-router-dom";
import styled from "styled-components";
import InnerContentWrapper from "../../styles/InnerContentWrapper";
import ProgramPost from "../post/ProgramPost";
import BioBox from "../sidebar/BioBox";
import ProgramSidebar from "../sidebar/ProgramSidebar";
import ProgressBox from "../sidebar/ProgressBox";
import ProgramPostPreview from "./ProgramPostPreview";
import ProgramNavigation from "../ProgramNavigation";
import { useSpring, animated } from "react-spring";

const SubSectionGrid = styled.div`
  display: grid;
  grid-template-columns: auto 340px;
  grid-column-gap: 2rem;
  @media (max-width: 1060px) {
    display: block;
    .subSections {
      margin-bottom: 2rem;
    }
  }
  .subSectionsWrapper {
  }
  .subSections {
    box-shadow: ${(props) => props.theme.boxShadow};
  }
  .categoryHeader {
    font-size: 20px;
    margin-bottom: 16px;
  }
`;

const SectionComponent = ({
  course,
  match,
  userLoading,
  userData,
  totalLessonsArray,
  completedTokens,
  getCompletedTokens,
}) => {
  const props = useSpring({
    from: { opacity: 0, transform: "translateY(-20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  });
  const programMainCategory = course.mainCategories.filter(
    (mainCategory) => mainCategory.mainCategoryId === match.params.sectionId
  )[0];

  const totalCompleted = totalLessonsArray.filter(
    (lesson) => completedTokens.indexOf(lesson.programPostId) > -1
  );

  return (
    <Switch>
      <Route
        path={`${match.url}/post/:postId`}
        render={(props) => (
          <ProgramPost
            userLoading={userLoading}
            userData={userData}
            programMainCategory={programMainCategory}
            courseId={course.courseId}
            courseName={course.courseTitle}
            completedTokens={completedTokens}
            getCompletedTokens={getCompletedTokens}
            {...props}
          />
        )}
      />
      <Route path={match.url}>
        <InnerContentWrapper>
          <ProgramNavigation>
            <span>
              <Link to={`/`}>My Courses</Link>
            </span>{" "}
            /{" "}
            <span>
              <Link to={`/course/${course.courseId}`}>
                {course.courseTitle}
              </Link>
            </span>{" "}
            / <span>{programMainCategory.mainCategoryTitle}</span>
          </ProgramNavigation>
          <SubSectionGrid>
            <div className="subSetcionsWrapper">
              <div className="subSections whiteBG innerPadding">
                {/* Map subsections */}
                {programMainCategory.subCategories.map((subCategory) => (
                  <animated.div style={props} key={subCategory.subCategoryId}>
                    <h2 className="categoryHeader">
                      {subCategory.subCategoryTitle}
                    </h2>
                    {subCategory.programPosts.map((post, index) => {
                      return (
                        <ProgramPostPreview
                          key={post.programPostId}
                          post={post}
                          currentPath={match.url}
                          completedTokens={completedTokens}
                        />
                      );
                    })}
                  </animated.div>
                ))}
              </div>
            </div>
            <ProgramSidebar>
              <ProgressBox
                completed={totalCompleted.length}
                total={totalLessonsArray.length}
              />
              <BioBox />
            </ProgramSidebar>
          </SubSectionGrid>
        </InnerContentWrapper>
      </Route>
    </Switch>
  );
};

export default SectionComponent;
